<script setup lang="ts">
import type { ParsedFilterData } from '@autobid/strapi-integration/server/trpc/routers/auctions/auctionsFilter'
import type { Ref } from 'vue'
import { useAuctionStore } from '@autobid/nuxt-pinia-store/store/useAuctionStore'
import { Combobox } from '@headlessui/vue'
import { storeToRefs } from 'pinia'
import AuctionButtonsContainer from './AuctionButtonsContainer.vue'
import AuctionListFilterButton from './AuctionListFilterButton.vue'

const auctionStoreKey = inject('auctionStoreKey')
const { filter } = storeToRefs(useAuctionStore(String(auctionStoreKey)))

const filterData = inject('filterData') as Ref<ParsedFilterData>
</script>

<template>
  <Combobox v-model="filter.countryIds" multiple>
    <AuctionButtonsContainer static>
      <AuctionListFilterButton
        v-for="country in filterData.countries"
        :key="country"
        :selected="filter.countryIds.includes(country.id)"
        :value="country.id"
      >
        <Icon mode="svg" :name="`cif:${country.isoCode.toLowerCase()}`" />
        {{ country.name }}
      </AuctionListFilterButton>
    </AuctionButtonsContainer>
  </Combobox>
</template>
